import React from "react";
import { CloseOutlined } from "@ant-design/icons";

import "./DialogPopupOptions.css";

function DialogPopupOptions({ regenerateDialogContent, setRegenerateDialogContent }) {
  return (
    <>
      {regenerateDialogContent.options.length > 0 && (
        <div className="dialop-popup-badges-section">
          <div className="dialop-popup-badges-label">Selected Options:</div>
          <div className="dialop-popup-badges">
            {regenerateDialogContent.options.map((option) => (
              <div key={option} className="dialop-popup-badge">
                <span className="dialop-popup-badge-text">{option}</span>
                <button
                  type="button"
                  onClick={() => {
                    setRegenerateDialogContent((prev) => ({
                      ...prev,
                      options: prev.options.filter((opt) => opt !== option),
                    }));
                  }}
                  className="dialop-popup-badge-remove"
                  aria-label={`Remove ${option}`}
                >
                  <CloseOutlined />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

export default DialogPopupOptions;
